module.exports = __webpack_public_path__ + "static/media/blog-4.d43c772e.jpg";